import { Injectable } from '@angular/core';
import { CompanyModel } from 'app/models/company.model';
import { CompanyService } from 'app/services/company.service';
// import { ThemePaletteService } from 'app/services/theme-palette.service';
import { StorageKeysService } from 'app/shared/services/storage-keys.service';
import { BehaviorSubject, filter, firstValueFrom, Observable, take, timeout } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DevstroupeInitAppService {
    private _currentCompany = new BehaviorSubject<CompanyModel>(null);
    currentCompany$: Observable<CompanyModel> = this._currentCompany.asObservable();

    constructor(private _skey: StorageKeysService) {}

    init(): Promise<void> {
        const token = localStorage.getItem(this._skey.token);
        if (!token) return Promise.resolve();

        // return firstValueFrom(
        //     this.companyService.currentCompany$.pipe(
        //         filter((c) => !!c),
        //         take(1),
        //         timeout(5000),
        //     ),
        // )
        //     .then((company) => {
        //         this.themePaletteService.applyPrimaryColor(company.primary_color);
        //     })
        //     .catch((err) => {
        //         console.warn('Init service: não recebeu company dentro do timeout, continuando bootstrap.', err);
        //         return;
        //     });
    }
}
